import React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import FullscreenDialogClose from '../../../FullscreenDialog/components/Close/Close';
import BackwardButton from '../../Button/components/BackwardButton/BackwardButton';
import { useIsMobile } from '../../../utils';
const Header = ({ className, classes, left, center, right, equalSlotsBasis = true, showEmptySlots = true, onClose, onGoBackward }) => {
    const theme = useTheme('BaseComponents').Header;
    const isMobile = useIsMobile();
    return (React.createElement("div", { className: cn(theme.wrapper, className) },
        React.createElement("div", { className: cn(theme.inner, classes === null || classes === void 0 ? void 0 : classes.inner) },
            onGoBackward && isMobile && React.createElement(BackwardButton, { onClick: onGoBackward }),
            (showEmptySlots || left) && (React.createElement("div", { className: cn(theme.leftSlot, classes === null || classes === void 0 ? void 0 : classes.leftSlot, {
                    [theme.equalSlotsBasis]: equalSlotsBasis
                }) }, left && left)),
            (showEmptySlots || center) && (React.createElement("div", { className: cn(theme.centerSlot, classes === null || classes === void 0 ? void 0 : classes.centerSlot, {
                    [theme.equalSlotsBasis]: equalSlotsBasis
                }) }, center)),
            (showEmptySlots || right) && (React.createElement("div", { className: cn(theme.rightSlot, classes === null || classes === void 0 ? void 0 : classes.rightSlot, {
                    [theme.equalSlotsBasis]: equalSlotsBasis
                }) }, right && right)),
            onClose && (React.createElement(FullscreenDialogClose, { closeClassName: cn(theme.closeWrapper, classes === null || classes === void 0 ? void 0 : classes.closeWrapper), textClassName: cn(theme.closeText, classes === null || classes === void 0 ? void 0 : classes.closeText), onClose: onClose })))));
};
export default Header;
